// Barcode Code 128 (set B: karakter ASCII 32-126) untuk label produk. Tanpa paket tambahan: hasilnya daftar lebar modul
// yang digambar langsung (PDF vektor, tajam di ukuran label kecil).
//
// Pola tiap simbol = lebar bar, spasi, bar, spasi, bar, spasi (jumlah 11 modul); STOP memiliki 7 angka (13 modul).
const POLA = [
  '212222', '222122', '222221', '121223', '121322', '131222', '122213', '122312', '132212', '221213',
  '221312', '231212', '112232', '122132', '122231', '113222', '123122', '123221', '223211', '221132',
  '221231', '213212', '223112', '312131', '311222', '321122', '321221', '312212', '322112', '322211',
  '212123', '212321', '232121', '111323', '131123', '131321', '112313', '132113', '132311', '211313',
  '231113', '231311', '112133', '112331', '132131', '113123', '113321', '133121', '313121', '211331',
  '231131', '213113', '213311', '213131', '311123', '311321', '331121', '312113', '312311', '332111',
  '314111', '221411', '431111', '111224', '111422', '121124', '121421', '141122', '141221', '112214',
  '112412', '122114', '122411', '142112', '142211', '241211', '221114', '413111', '241112', '134111',
  '111242', '121142', '121241', '114212', '124112', '124211', '411212', '421112', '421211', '212141',
  '214121', '412121', '111143', '111341', '131141', '114113', '114311', '411113', '411311', '113141',
  '114131', '311141', '411131', '211412', '211214', '211232', '2331112',
];
const MULAI_B = 104;
const STOP = 106;

/** Teks bisa dibuat Code 128 set B? (tidak kosong, hanya ASCII 32-126) */
export const bisaCode128 = (teks) => typeof teks === 'string' && teks.length > 0 && /^[\x20-\x7e]+$/.test(teks);

/** Nilai simbol (termasuk mulai, checksum, stop) untuk teks. */
export const simbolCode128 = (teks) => {
  if (!bisaCode128(teks)) throw new Error('Kode tidak bisa dibuat barcode Code 128 (hanya huruf, angka, dan tanda baca biasa)');
  const nilai = [MULAI_B];
  let jumlah = MULAI_B;
  for (let i = 0; i < teks.length; i += 1) {
    const v = teks.charCodeAt(i) - 32;
    nilai.push(v);
    jumlah += v * (i + 1);
  }
  nilai.push(jumlah % 103, STOP);
  return nilai;
};

/** Barisan modul (1 = bar hitam, 0 = spasi) tanpa zona hening. */
export const modulCode128 = (teks) => {
  const modul = [];
  for (const v of simbolCode128(teks)) {
    [...POLA[v]].forEach((lebar, idx) => {
      for (let k = 0; k < Number(lebar); k += 1) modul.push(idx % 2 === 0 ? 1 : 0);
    });
  }
  return modul;
};

/** Jumlah modul seluruh barcode (tanpa zona hening): 11 per karakter + 35 (mulai, checksum, stop). */
export const jumlahModulCode128 = (teks) => 11 * (teks.length + 2) + 13;

export const POLA_CODE128 = POLA;
